export enum ActionTypes {
    SET_REPORT = "SET_REPORT",
    SET_ERROR = "SET_ERROR",
    FETCH_REPORT = "FETCH_REPORT"
}